import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NGXLogger as LoggerService } from "ngx-logger";
import { ReadMoreComponent } from "../../read-more/read-more.component";


@Component({
    selector: 'article-bottom',
    standalone: true,
    imports: [
        CommonModule,
        ReadMoreComponent
    ],
    templateUrl: './article-bottom.component.html',
    styleUrls: ['./../articles.scss'],
})

export class ArticleBottomComponent {

    constructor(
    ) {
    }

}
